import React from "react";
import "../css/PosSidebar.css";

const Sidebar = ({ isOpen, closeSidebar }) => {
  return (
    <div className={`custom-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header d-flex justify-content-between align-items-center">
        <h5 className="text-white">Menu</h5>
        <button className="btn text-white fs-4" onClick={closeSidebar}>&times;</button>
      </div>

      <ul className="sidebar-links">
        <li><a href="/dashboard">Dashboard</a></li>
        <li><a href="/orders">Orders</a></li>
        <li><a href="/products">Products</a></li>
        <li><a href="/settings">Settings</a></li>
      </ul>
    </div>
  );
};

export default Sidebar;
